import { RoleInfo, RoleResponse } from '../services/api';

/** Default agency role assigned via WorkOS; not shown in user-facing role pickers. */
export const HIDDEN_USER_ROLE_SLUGS: readonly string[] = ['member'] as const;

/** Permission slug for users assignable as visit clinicians (mirrors backend). */
export const CLINIC_ASSIGNABLE_CLINICIAN_PERMISSION =
  'clinic:assignable-as-clinician';

/** System role slug for assignable-as-clinician (mirrors backend). */
export const CLINIC_CLINICIAN_ROLE_SLUG = 'clinic:clinician';

export function isUserVisibleRole(role: RoleResponse | RoleInfo): boolean {
  return !HIDDEN_USER_ROLE_SLUGS.includes(role.slug);
}

export function filterUserVisibleRoles<T extends RoleResponse | RoleInfo>(
  roles: T[]
): T[] {
  return roles.filter(isUserVisibleRole);
}

export function isAssignableClinicianRole(role: RoleResponse): boolean {
  if (role.slug === CLINIC_CLINICIAN_ROLE_SLUG) return true;
  return (
    role.permissions?.some(
      permission => permission.slug === CLINIC_ASSIGNABLE_CLINICIAN_PERMISSION
    ) ?? false
  );
}

/** Union of clinic IDs selected on any assignable-clinician role. */
export function collectAssignableClinicIds(
  clinicRoles: RoleResponse[],
  clinicSelection: ReadonlyMap<string, ReadonlySet<string>>
): Set<string> | undefined {
  const assignableRoles = clinicRoles.filter(isAssignableClinicianRole);
  if (assignableRoles.length === 0) return undefined;

  const ids = new Set<string>();
  for (const role of assignableRoles) {
    for (const clinicId of clinicSelection.get(role.id) ?? []) {
      ids.add(clinicId);
    }
  }
  return ids;
}
